<template>
  <div class="order-descript">
    <div class="base">
      <Title :title="`基本信息`"></Title>
      <div class="info" v-if="Object.keys(resultData).length>0">
        <div class="info-title">
          <ul>
            <li>
              <span>订单号：</span>
              <span>{{resultData.order_no}}</span>
            </li>
            <li>
              <span>订单类型：</span>
              <span>普通订单</span>
            </li>
            <li>
              <span>订单状态：</span>
              <span v-show="resultData.pay_state==1">待支付</span>
              <span v-show="resultData.pay_state==2">已支付</span>
              <span v-show="resultData.pay_state==3">已退款</span>
              <span v-show="resultData.pay_state==4">支付失败</span>
            </li>
          </ul>
        </div>
        <div class="space"></div>

        <div class="info-title">
          <ul>
            <li>
              <span>下单时间：</span>
              <span>{{resultData.created_at}}</span>
            </li>
            <li>
              <span>支付方式：</span>
              <span v-show="resultData.pay_mode==1">微信支付</span>
              <span v-show="resultData.pay_mode==2">支付宝支付</span>
            </li>
            <li>
              <span>优惠信息：</span>
              <span>已减免{{resultData.reduction_amount}}元</span>
            </li>
            <li>
              <span>支付时间：</span>
              <span>{{resultData.pay_at}}</span>
            </li>
            <li>
              <span>收款方式：</span>
              <span>自有服务号账户收款</span>
            </li>
            <li>
              <span>营销活动：</span>
              <span>---</span>
            </li>
            <li>
              <span>结算时间：</span>
              <span>{{resultData.pay_at}}</span>
            </li>
            <li>
              <span>渠道来源：</span>
              <span v-show="resultData.order_channel==1">微信小程序</span>
              <span v-show="resultData.order_channel==2">h5</span>
            </li>
            <li>
              <span>分销信息：</span>
              <span>---</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="wx mt20">
      <Title :title="`微信支付信息`"></Title>
      <div class="info">
        <div class="info-title">
          <ul>
            <li>
              <span>交易单号：</span>
              <span>{{resultData.transaction_id}}</span>
            </li>
            <li>
              <span>商户单号：</span>
              <span>346567898705435457689</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="buy mt20">
      <Title :title="`买家信息`"></Title>
      <div class="info">
        <div class="info-title">
          <ul>
            <li>
              <span>买家昵称：</span>
              <span>{{resultData.user_nick_name}}</span>
            </li>
            <li>
              <span>联系电话：</span>
              <span>{{resultData.user_mobile}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="list-wrap">
      <div class="block">
        <el-row class="t-header">
          <el-col :span="4">商品名称</el-col>
          <el-col :span="4">商品类型</el-col>
          <el-col :span="4">单价</el-col>
          <el-col :span="4">优惠</el-col>
          <el-col :span="4">小计</el-col>
          <el-col :span="4">售后</el-col>
        </el-row>
        <el-row class="info">
          <el-col :span="4">{{resultData.goods_name}}</el-col>
          <el-col :span="4">{{resultData.goods_type}}</el-col>
          <el-col :span="4">{{resultData.goods_price}}</el-col>
          <el-col :span="4">{{resultData.reduction_amount}}</el-col>
          <el-col :span="4">{{resultData.goods_quantity}}</el-col>
          <el-col :span="4">
            <el-button type="text" v-if="resultData.pay_state==1" size="mini">待支付</el-button>
            <el-button type="text" v-if="resultData.pay_state==2" size="mini" @click="refundSign(resultData)" >退款标注</el-button>
            <el-button type="text" v-if="resultData.pay_state==3" size="mini">已退款</el-button>            
            <el-button type="text" v-if="resultData.pay_state==4" size="mini">支付失败</el-button>                        
          </el-col>
        </el-row>
      </div>

      <div class="space mt20"></div>
      <div class="order-list">订单合计{{resultData.goods_quantity}}件商品，实付：¥{{resultData.total_amount}}</div>

      <!-- <div class="tc">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(resultData.count)"
        ></el-pagination>
      </div>-->
    </div>
    <!-- 标注弹框 -->
    <el-dialog title="退款标注" :visible.sync="signDialogVisible" width="30%">
      <div class="product-info">
        <div class="left">
          <p class="title">商品名称</p>
          <p class="item">{{order_info.goods_name}}</p>
        </div>
        <div class="right">
          <p class="title">退款金额（元）</p>
          <p class="item" style="padding-right:20px;">￥{{order_info.total_amount}}</p>
        </div>
      </div>
      <div slot="footer" class="tc">
        <el-button @click="signDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import Title from "@/components/title";

import { _orderSingleInfo ,_orderRrfund} from "@/api/order";

export default {
  data() {
    return {
      order_info: {},
      signDialogVisible: false,
      resultData: {
      }
    };
  },
  created() {
    // console.log(this.$route.params.id)
    this.orderSingleInfo();
  },
  props: {
    order_id: {
      type: String,
      default: ""
    }
  },
  components: {
    Title
  },
  methods: {
    //加载订单信息详情
    orderSingleInfo() {
      _orderSingleInfo({
        params: {
          id: this.$route.params.id
        }
      }).then(res => {
        if (res.resultCode == 1) {
          this.resultData = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    // 退款标注
    refundSign(item) {
      this.order_info = item;
      this.signDialogVisible = true;
    },
    orderSingleRrfund(){
       _orderRrfund({
        params: {
          id: this.order_info.order_id
        }
      }).then(res => {
        if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
          this.orderSingleInfo();
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //提交金额
    submit() {
      this.orderSingleRrfund();
      this.signDialogVisible = false;
    }
  }
};
</script>



<style lang="less" scoped>
.order-descript {
  .space {
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: inset;
    border-width: 1.5px;
  }
  .info {
    padding-left: 12px;
  }
  .info-title {
    overflow: hidden;
    ul li {
      line-height: 30px;
      width: 30%;
      float: left;
      min-width: 300px;
      overflow: hidden;
    }
  }
  .list-wrap {
    margin-top: 40px;
    .order-list {
      text-align: right;
      font-size: 16px;
      padding-right: 20px;
      line-height: 30px;
    }
  }
  .product-info {
    display: flex;
    .left {
      flex: 1;
      text-align: left;
    }
    .right {
      flex: 1;
      text-align: right;
    }
    .title {
      font-size: 16px;
      margin-bottom: 20px;
    }
  }
  .block {
    .t-header {
      margin-top: 20px;
      background-color: @table-bg;
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      font-weight: bold;
      // color: #909399;
    }
    .info {
      background-color: #fefefe;
      height: 60px;
      line-height: 60px;
      padding: 0 20px;
      font-weight: 500;
    }
  }
}
</style>
